module.exports = __webpack_public_path__ + "img/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_kachel-cannaloe.3244c479.png";